import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IInventory } from "../../@types";
import ProductAndServicesLoader from "./Loading/ProductAndServicesLoader";
import { useInventoryStore } from "../../state/useInventoryStore";

const StockAlert = ({ businessType }: { businessType?: string }) => {
  const navigate = useNavigate();
  const {
    outOfStockInventories,
    setFilters: handleFilter,
    fetchOutOfStockData,
    isLoadingFilter,
  } = useInventoryStore();

  React.useEffect(() => {
    handleFilter({
      stockStatus: "out-of-stock",
      variantStatus: "",
    });
    fetchOutOfStockData({ actionType: "filter" });
  }, []);

  if (isLoadingFilter) {
    return <ProductAndServicesLoader />;
  }

  return (
    <div className="rounded-lg bg-white items-stretch py-3 lg:py-6 flex w-full">
      <>
        {outOfStockInventories?.length > 0 ? (
          <div className="flex flex-col justify-between w-full">
            <div className="w-full">
              <h2 className="px-3 md:px-6 text-[#1D2939] text-[16px] font-medium leading-6">
                Stock Alert
              </h2>
              <hr className="border border-[#EAECF0] w-full mt-3 mb-2" />
              <div className="space-y-2 px-3 md:px-6">
                {outOfStockInventories
                  ?.splice(0, 5)
                  ?.map((inventory: IInventory, index) => (
                    <div
                      id={inventory.id}
                      key={inventory.id}
                      className="flex justify-between items-center py-2 "
                    >
                      <div>
                        <p className="text-[#1D2939] mb-[2px] font-medium text-[16px] leading leading-5">
                          {inventory.name}
                        </p>
                        <p className="text-[#667085] text-sm font-normal">
                          {inventory.variations.length > 0
                            ? `${inventory.variations.length} Variations`
                            : "No Variation"}
                        </p>
                      </div>
                      <div>
                        <p className="text-[#D92D20] mb-[2px] text-sm font-semibold leading leading-5">
                          {inventory.quantity} Left
                        </p>
                        <button
                          onClick={() =>
                            navigate(`/inventories/${inventory.id}/restock`)
                          }
                          className="text-[#044E97] underline text-[16px] font-semibold leading leading-5"
                        >
                          Restock
                        </button>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
            <div className="flex justify-between mx-auto w-full items-center px-2">
              <button className="border-[#044E97] mx-auto transition-all duration-500 hover:bg-[#044E97] hover:text-[#ffffff] p-[8px] border rounded-md text-[14px] font-medium text-[#044E97] ">
                View Inventory
              </button>
            </div>
          </div>
        ) : (
          <div className="flex flex-col justify-between w-full">
            <div className="w-full">
              <h2 className="px-3 md:px-6 text-[#1D2939] text-[16px] font-medium leading-6">
                Stock Alert
              </h2>
              <hr className="border border-[#EAECF0] w-full mt-3 mb-2" />
              <div className="bg-white w-full flex md:py-16 justify-center items-center h-full p-3">
                <div className="flex flex-col justify-center items-center mt-10 gap-5">
                  <p className="text-[#344054] text-[14px] font-medium leading-5 text-center">
                    You do not have any out-of-stock inventory.
                  </p>
                  <button
                    onClick={() => {
                      if (businessType == "service") {
                        navigate("/services/create");
                      } else {
                        navigate("/inventories/create");
                      }
                    }}
                    className="px-4 text-[#044E97] text-[14px] font-medium leading-5  cursor-pointer"
                  >
                    {businessType == "service"
                      ? "Create a service"
                      : "Create an Inventory"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    </div>
  );
};

export default StockAlert;
